/********************************************************************
 * ADOBE CONFIDENTIAL
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { PlaceOrderResponse } from '@/order/types';
import { OrderDataModel } from '../models';
import { transformOrderData } from './transform-order-details';

export const transformPlaceOrder = (
  response: PlaceOrderResponse
): OrderDataModel | null => {
  const orderData = response?.data?.placeOrder?.orderV2;
  if (!orderData) return null;
  return transformOrderData(orderData);
};
